import React from 'react';
import { Card } from '../ui/card';
import { Navigation } from 'lucide-react';

const NavigationInfoCard = ({ navigationInfo }) => {
  if (!navigationInfo) return null;

  return (
    <Card className="p-6 bg-blue-50 border-blue-200">
      <div className="flex items-center gap-2 mb-3">
        <Navigation className="h-5 w-5 text-blue-600" />
        <h2 className="text-lg font-bold text-blue-900">Navigation</h2>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <p className="text-sm text-blue-700">Estimated Time</p>
          <p className="text-2xl font-bold text-blue-900">{navigationInfo.duration} min</p>
        </div>
        <div>
          <p className="text-sm text-blue-700">Distance</p>
          <p className="text-2xl font-bold text-blue-900">{navigationInfo.distance} km</p>
        </div>
      </div>
      <p className="text-xs text-blue-600 mt-3">
        Turn-by-turn directions shown on map with live traffic
      </p>
    </Card>
  );
};

export default NavigationInfoCard;
